<template>
  <div>
    <hr class="mb-half" style="margin-top: 18px !important" v-if="hasBorderTop" />
    <div class="section-header--wrapper">
      <div
        class="section-title has-text-weight-bold has-text-black"
        :class="[titleSize,  {'truncated-title': seeAllPath}]"
      >{{ title }}</div>

      <div
        v-if="seeAllPath"
        class="section-header--see-all ml-auto"
        :style="{'padding-top': titleMd ? '6px' : titleLg ? '8px' : '1px' }"
      >
        <router-link :to="seeAllPath" class="has-text-link">{{ $t('ui.seeAll') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "section-header",
  props: {
    title: {
      type: String,
      required: true
    },
    titleSm: {
      type: Boolean,
      default: false
    },
    titleMd: {
      type: Boolean,
      default: false
    },
    titleLg: {
      type: Boolean,
      default: false
    },
    seeAllPath: {
      type: String,
      default: ""
    },
    hasBorderTop: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    titleSize() {
      return this.titleLg
        ? "is-size-4"
        : this.titleMd
        ? "is-size-5"
        : "is-size-18px";
    }
  }
};
</script>

<style lang="scss" scoped>
.section-header--wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 4px;
  // width: 100%;
}
.section-title {
  line-height: 1.35 !important;
  flex-grow: 1;
}
.truncated-title {
  max-width: calc(100vw - 122px);
}
.flex-no-grow {
  flex-grow: 0 !important;
}
</style>